import { render, staticRenderFns } from "./approvalOpinion.vue?vue&type=template&id=3c1c3006&scoped=true"
import script from "./approvalOpinion.vue?vue&type=script&lang=js"
export * from "./approvalOpinion.vue?vue&type=script&lang=js"
import style0 from "./approvalOpinion.vue?vue&type=style&index=0&id=3c1c3006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c3006",
  null
  
)

export default component.exports